import { render, staticRenderFns } from "./independent.vue?vue&type=template&id=3f838b3e&scoped=true"
import script from "./independent.vue?vue&type=script&lang=js"
export * from "./independent.vue?vue&type=script&lang=js"
import style0 from "./independent.vue?vue&type=style&index=0&id=3f838b3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f838b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f838b3e')) {
      api.createRecord('3f838b3e', component.options)
    } else {
      api.reload('3f838b3e', component.options)
    }
    module.hot.accept("./independent.vue?vue&type=template&id=3f838b3e&scoped=true", function () {
      api.rerender('3f838b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSalesSetting/independent.vue"
export default component.exports